<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>指挥中心</el-breadcrumb-item>
			<el-breadcrumb-item>设备状况查询</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-form :inline="true" v-if="userWorkshopId">
				<el-form-item label="当前车间">
					<span>{{ workshopInfo.name }}</span>
				</el-form-item>
			</el-form>
			<el-form :inline="true" v-else>
				<el-form-item label="车间选择">
					<el-select v-model="workshop" placeholder="车间选择" :clearable="true">
						<el-option v-for="item in workshops" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="info" v-on:click="handleSearch">查询</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div>
			<el-table border :data="tableData" v-loading="tableLoading" :default-sort="{ prop: 'startTime', order: 'descending' }">
				<el-table-column prop="workshop.name" label="车间" width="120" sortable :sort-method="sortWorkshopName"></el-table-column>
				<el-table-column label="设备名称" width="150" sortable :sort-method="sortJTName">
					<template slot-scope="scope">
						<el-button type="text" v-on:click="handleViewDetails(scope.row)">
							<span v-text="scope.row.name"></span>
						</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="code" label="工单号" width="100" sortable :sort-method="sortOrderCode"></el-table-column>
				<el-table-column prop="yield_rate" label="良品率" width="100" sortable></el-table-column>
				<el-table-column prop="status" label="机器状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="getJTStatusTagType(scope.row.status)" v-text="scope.row.status_text"></el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="startTime" label="开机时间" width="180" sortable></el-table-column>
				<el-table-column prop="remaining" label="剩余时间（分钟）" width="180" sortable></el-table-column>
				<el-table-column prop="progress" :formatter="progressFormatter" label="生产进度" width="120" sortable></el-table-column>
				<el-table-column label="工艺参数" align="center">
					<el-table-column :label="item.name" align="center" width="90" v-for="item in teches" :key="item._id.$oid">
						<template slot-scope="scope">
							<span v-text="getTechValue(scope.row, item._id.$oid)"></span>
						</template>
					</el-table-column>
				</el-table-column>
			</el-table>

			<!--分页-->
			<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
		</div>
	</div>
</template>

<script>
	import dictionaryData from '@/service/dictionaryData'
	import jtService from '@/service/jtService'
	import moment from 'moment'
	import { techInfoRequest } from '../../network/requests/techInfo'
	import { jtTechRequest } from '@/network/requests/jtTech'
	import { mapGetters } from 'vuex'
	import { workshopRequest } from '@/network/requests/workshop'
	export default {
		components: {},
		data() {
			return {
				workshop: '',
				workshops: [],
				workshopInfo: {},
				pageSize: 10,
				pageIndex: 1,
				pageCount: 1,
				tableData: [],
				tableLoading: false,
				teachGroupDetailDialogVisible: false,
				selectedTeachGroupId: '',
				teches: [],
				loopInterval: null,
			}
		},
		computed: {
			...mapGetters(['userInfo', 'userWorkshopId']),
		},
		methods: {
			/**
			 * 格式化进度。
			 */
			progressFormatter(row, column, cellValue, index) {
				return cellValue + ' %'
			},
			/**
			 * 工单号排序。
			 */
			sortOrderCode(a, b) {
				if (a.workCode) return a.workCode.localeCompare(b.workCode, 'zh')

				return 0
			},
			/**
			 * 产品名称排序。
			 */
			sortProductName(a, b) {
				if (a.productName) return a.productName.localeCompare(b.productName, 'zh')

				return 0
			},
			/**
			 * 机台名称排序。
			 */
			sortJTName(a, b) {
				return a.name.localeCompare(b.name, 'zh')
			},
			/**
			 * 车间名称排序。
			 */
			sortWorkshopName(a, b) {
				return a.workshop.name.localeCompare(b.workshop.name, 'zh')
			},
			/**
			 * 获取查询条件。
			 */
			getFilter() {
				var filter = {
					jt_id: '',
					workshop_id: this.workshop,
				}

				//如果查询条件都没有，则直接返回未定义，避免参数查询。
				if (!filter.jt_id && !filter.workshop_id) return undefined

				return filter
			},
			/**
			 * 提交查询。
			 */
			handleSearch() {
				this.pageIndex = 1
				this.tableLoading = true
				this.query()
			},
			/**
			 * 查询数据。
			 */
			query() {
				//获取过滤条件。
				var filter = this.getFilter()

				jtService.getDeviceStatusList(this.pageIndex, this.pageSize, filter).then(res => {
					var newList = []
					var techParamsTask = []
					res.data.forEach((v, i) => {
						//获取机台的工艺参数信息。
						var p = jtTechRequest.queryAll({ jt_id: v.id })
						techParamsTask.push(p)
					})

					//等待获取机台的工艺参数信息。
					Promise.all(techParamsTask).then(results => {
						res.data.forEach((v, i) => {
							v.techs = results[i]
							newList.push(v)
						})

						this.tableData = newList

						setTimeout(() => {
							this.tableLoading = false
						}, 1000)
					})

					this.pageCount = res.pageCount
				})
			},
			/**
			 * 获取机台运行状态的标签的类型。
			 */
			getJTStatusTagType(status) {
				var tagTypes = {
					0: 'danger',
					1: 'success',
				}
				if (!status) {
					return 'black'
				}

				if (tagTypes[status]) {
					return tagTypes[status]
				}

				return 'waring'
			},
			/**
			 * 切换页码。
			 */
			handleCurrentChange(page) {
				clearInterval(this.loopInterval)
				this.tableLoading = true
				this.pageIndex = page
				this.query()

				//定时刷新。
				this.loopInterval = setInterval(() => {
					this.query()
				}, 10000)
			},
			/**
			 * 修改每页记录数量。
			 */
			handleSizeChange(size) {
				clearInterval(this.loopInterval)
				this.tableLoading = true
				this.pageIndex = 1
				this.pageSize = size
				this.query()

				//定时刷新。
				this.loopInterval = setInterval(() => {
					this.query()
				}, 10000)
			},
			/**
			 * 获取工艺信息。
			 */
			getTechValue(row, techId) {
				var tech = row.techs.find(t => t.tech_id == techId)
				if (tech) {
					return tech.value
				}

				return '--'
			},
			/**
			 * 查看详情。
			 */
			handleViewDetails(row) {
				this.$router.push({ name: 'WorkshopView', query: { jt_id: row.id } })
			},
		},
		async created() {
			this.tableLoading = true

			if (this.userWorkshopId) {
				this.workshop = this.userWorkshopId
				this.workshopInfo = (await workshopRequest.getDocumentById(this.userWorkshopId)).data
			} else {
				this.workshops = await dictionaryData.getWorkshops()
			}

			this.teches = await techInfoRequest.queryAll()

			//加载数据。
			this.query()

			//定时刷新。
			this.loopInterval = setInterval(() => {
				this.query()
			}, 10000)
		},
		destroyed() {
			clearInterval(this.loopInterval)
		},
	}
</script>
